import React from "react"
import CompanySubscriptionsTable from "./components/tables/CompanySubscriptionsTable";

export default class CompanySubscriptions extends React.Component {

  constructor(props) {
    super(props)

    this.state = {

    }
  }

  render() {
    let {

    } = this.state

    return (
      <>
        <CompanySubscriptionsTable
          title={'Billing'}
        />
      </>
    )
  }

}
